module.exports = __webpack_public_path__ + "img/img1.0b0dc70b.png";